import { create } from "zustand";

import { AudioSliceState, createAudioSlice } from "./slices/audio";
import { CallSliceState, createCallSlice } from "./slices/call";
import {
  CompanyTagsSliceState,
  createCompanyTagsSlice,
} from "./slices/company_tags";
import {
  EvaluationTabSourceSliceState,
  createEvaluationTabSourceSlice,
} from "./slices/evaluation_tab_source";
import {
  ExpandedStateSliceState,
  createExpandedStateSlice,
} from "./slices/expanded_state";
import {
  SearchContentMatchesSliceState,
  createSearchContentMatchesSlice,
} from "./slices/search_content_matches";
import { TagSliceState, createTagSlice } from "./slices/tag";
import {
  TimelineModeSliceState,
  createTimelineModeSlice,
} from "./slices/timeline_mode";
import {
  TranscriptionSettingsSliceState,
  createTranscriptionSettingsSlice,
} from "./slices/transcription_settings";

export type BaseStoreState = TagSliceState &
  AudioSliceState &
  CallSliceState &
  TranscriptionSettingsSliceState &
  ExpandedStateSliceState &
  SearchContentMatchesSliceState &
  TimelineModeSliceState &
  CompanyTagsSliceState &
  EvaluationTabSourceSliceState;

export const useBaseStore = create<BaseStoreState>((...rest) => ({
  // asset page slices
  ...createTagSlice(...rest),
  ...createAudioSlice(...rest),
  ...createTranscriptionSettingsSlice(...rest),
  ...createExpandedStateSlice(...rest),
  ...createTimelineModeSlice(...rest),
  ...createSearchContentMatchesSlice(...rest),
  ...createCompanyTagsSlice(...rest),
  ...createEvaluationTabSourceSlice(...rest),
  ...createCallSlice(...rest),
}));
